// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Canonical enemy-roster rail — the single enemy-display element for BOTH combat
 * engines (batch cross-enemy swarm + simultaneous pools). These base rules were
 * relocated here from pages/BatchBossSession.css (2026-07-09 sc-tiles retirement)
 * so the rail loads wherever <EnemyRosterRail> renders, not just the batch page.
 *
 * The --bcb-* vars resolve from .batch-boss on the batch page (unchanged look);
 * the fallbacks make the rail self-sufficient on the simultaneous-combat page.
 * Batch-context overrides (.batch-combat-strip-inline / responsive / dialysis)
 * still live in BatchBossSession.css and win by specificity. */

.mini-boss-enemy-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(142px, 1fr));
  gap: 6px;
  margin-top: 2px;
}

.mini-boss-enemy {
  min-width: 0;
  padding: 6px 7px;
  border: 1px solid var(--bcb-border, rgba(255, 255, 255, 0.07));
  border-left: 2px solid var(--bcb-border-strong, rgba(255, 255, 255, 0.14));
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.025);
}

/* Main boss reads as the primary threat — spans two grid tracks. */
.mini-boss-enemy--boss {
  grid-column: span 2;
}

.mini-boss-enemy--target {
  border-left-color: var(--bcb-accent-strong, rgba(239, 68, 68, 0.55));
  background: var(--bcb-accent-soft, rgba(239, 68, 68, 0.08));
}

/* Click-to-target (focus-fire) affordance */
.mini-boss-enemy--clickable {
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease, transform 120ms ease;
}
.mini-boss-enemy--clickable:hover {
  border-color: var(--bcb-accent-strong, rgba(239, 68, 68, 0.55));
  background: rgba(255, 255, 255, 0.055);
}
.mini-boss-enemy--clickable:focus-visible {
  outline: 2px solid var(--bcb-accent-strong, rgba(239, 68, 68, 0.55));
  outline-offset: 1px;
}

/* Dead enemy — dimmed, not targetable */
.mini-boss-enemy--dead {
  opacity: 0.4;
  filter: grayscale(0.6);
  cursor: default;
}

/* Invulnerable enemy (simultaneous boss while lieutenants stand) — purple */
.mini-boss-enemy--invuln {
  opacity: 0.9;
  border-left-color: rgba(139, 92, 246, 0.6);
  background: rgba(139, 92, 246, 0.06);
}
.mini-boss-enemy--invuln .mini-boss-enemy-node {
  color: #c4b5fd;
}
.mini-boss-enemy--invuln .mini-boss-enemy-fill {
  background: linear-gradient(90deg, #8b5cf6, #a78bfa);
}

/* Spawned mid-fight mini (simultaneous spawn pools) — dashed amber edge + a
 * one-shot entry flash (the element mounts fresh, keyed by identity). */
.mini-boss-enemy--spawned {
  border-left-style: dashed;
  border-left-color: rgba(245, 158, 11, 0.7);
  animation: miniBossEnemySpawn 700ms ease-out;
}
.mini-boss-enemy--spawned .mini-boss-enemy-node {
  color: #fbbf24;
}
@keyframes miniBossEnemySpawn {
  0% { transform: scale(0.9); opacity: 0; }
  40% { transform: scale(1.04); opacity: 1; box-shadow: 0 0 18px rgba(245, 158, 11, 0.55); }
  100% { transform: scale(1); box-shadow: none; }
}

/* Enemy currently performing its attack — red flash */
.mini-boss-enemy--attacking {
  border-color: #ef4444;
  border-left-color: #ef4444;
  background: rgba(239, 68, 68, 0.14);
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.5), 0 0 14px rgba(239, 68, 68, 0.35);
  animation: miniBossEnemyAttack 0.5s ease;
}
@keyframes miniBossEnemyAttack {
  0% { transform: scale(1); box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.2), 0 0 0 rgba(239, 68, 68, 0); }
  35% { transform: scale(1.04); box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.75), 0 0 18px rgba(239, 68, 68, 0.5); }
  100% { transform: scale(1); }
}

.mini-boss-enemy-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  min-width: 0;
  margin-bottom: 5px;
}

.mini-boss-enemy-name,
.mini-boss-enemy-node,
.mini-boss-enemy-hp {
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-variant-numeric: tabular-nums;
}

.mini-boss-enemy-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--bcb-text, #f5f5f5);
}

/* Inline clinical pathophys label after the gamified name (e.g. "ANGIRA [RAAS]").
   Same FONT as the gamified name (weight + tracking match .mini-boss-enemy-name) so
   it reads as one typeface; only the dim color and non-caps casing (preserves e.g.
   "Lp(a)") set it apart. Extra left margin separates it from the name. Rides inside
   the ellipsizing name span, so it truncates gracefully on a narrow rail. */
.mini-boss-enemy-subconcept {
  text-transform: none;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--bcb-text-dim, rgba(255, 255, 255, 0.5));
  margin-left: 0.3em;
}

.mini-boss-enemy-node,
.mini-boss-enemy-hp {
  color: var(--bcb-text-dim, rgba(255, 255, 255, 0.62));
  white-space: nowrap;
}

.mini-boss-enemy-track {
  height: 4px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.08);
  /* relative so the diuresis reserve segment anchors to the track; overflow:hidden
     already clips it to the pill. */
  position: relative;
}

.mini-boss-enemy-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #ef4444, #f97316);
  transition: width 180ms ease;
}

/* Diuresis "reserve" segment (Edward 2026-07-24): mirrors HPBar's .hp-pill-reserve-
   fill for the roster-rail bar (which has its own markup). The HP the diuresis drain
   will remove from this enemy next interaction (even-split share), overlaying the
   right edge of the green fill — left/width set inline (left = pct - reservePct).
   Diuresis cyan rgb(56,189,248). Only rendered when reservePct > 0, so non-HTN
   rosters are untouched. */
.mini-boss-enemy-reserve-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  min-width: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(56, 189, 248, 0.85) 0%, rgb(56, 189, 248) 100%);
  box-shadow: inset 1px 0 0 rgba(56, 189, 248, 0.55);
  transition: width 180ms ease, left 180ms ease;
}

.mini-boss-enemy-hp {
  margin-top: 4px;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/components/Combat/EnemyRosterRail.css"],"names":[],"mappings":"AAAA;;;;;;;;+DAQ+D;;AAE/D;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,8DAA8D;EAC9D,0EAA0E;EAC1E,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,mEAAmE;AACnE;EACE,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;EACpE,2DAA2D;AAC7D;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,gFAAgF;AAClF;AACA;EACE,+DAA+D;EAC/D,sCAAsC;AACxC;AACA;EACE,oEAAoE;EACpE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;EACE,YAAY;EACZ,0CAA0C;EAC1C,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,oDAAoD;AACtD;;AAEA;wEACwE;AACxE;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,cAAc;AAChB;AACA;EACE,KAAK,qBAAqB,EAAE,UAAU,EAAE;EACxC,MAAM,sBAAsB,EAAE,UAAU,EAAE,6CAA6C,EAAE;EACzF,OAAO,mBAAmB,EAAE,gBAAgB,EAAE;AAChD;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,mCAAmC;EACnC,8EAA8E;EAC9E,wCAAwC;AAC1C;AACA;EACE,KAAK,mBAAmB,EAAE,wEAAwE,EAAE;EACpG,MAAM,sBAAsB,EAAE,8EAA8E,EAAE;EAC9G,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;;;4EAI4E;AAC5E;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;;EAEE,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC;oCACkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;;;;;2BAK2B;AAC3B;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,uFAAuF;EACvF,kDAAkD;EAClD,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["/* Canonical enemy-roster rail — the single enemy-display element for BOTH combat\n * engines (batch cross-enemy swarm + simultaneous pools). These base rules were\n * relocated here from pages/BatchBossSession.css (2026-07-09 sc-tiles retirement)\n * so the rail loads wherever <EnemyRosterRail> renders, not just the batch page.\n *\n * The --bcb-* vars resolve from .batch-boss on the batch page (unchanged look);\n * the fallbacks make the rail self-sufficient on the simultaneous-combat page.\n * Batch-context overrides (.batch-combat-strip-inline / responsive / dialysis)\n * still live in BatchBossSession.css and win by specificity. */\n\n.mini-boss-enemy-strip {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(142px, 1fr));\n  gap: 6px;\n  margin-top: 2px;\n}\n\n.mini-boss-enemy {\n  min-width: 0;\n  padding: 6px 7px;\n  border: 1px solid var(--bcb-border, rgba(255, 255, 255, 0.07));\n  border-left: 2px solid var(--bcb-border-strong, rgba(255, 255, 255, 0.14));\n  border-radius: 7px;\n  background: rgba(255, 255, 255, 0.025);\n}\n\n/* Main boss reads as the primary threat — spans two grid tracks. */\n.mini-boss-enemy--boss {\n  grid-column: span 2;\n}\n\n.mini-boss-enemy--target {\n  border-left-color: var(--bcb-accent-strong, rgba(239, 68, 68, 0.55));\n  background: var(--bcb-accent-soft, rgba(239, 68, 68, 0.08));\n}\n\n/* Click-to-target (focus-fire) affordance */\n.mini-boss-enemy--clickable {\n  cursor: pointer;\n  transition: border-color 120ms ease, background 120ms ease, transform 120ms ease;\n}\n.mini-boss-enemy--clickable:hover {\n  border-color: var(--bcb-accent-strong, rgba(239, 68, 68, 0.55));\n  background: rgba(255, 255, 255, 0.055);\n}\n.mini-boss-enemy--clickable:focus-visible {\n  outline: 2px solid var(--bcb-accent-strong, rgba(239, 68, 68, 0.55));\n  outline-offset: 1px;\n}\n\n/* Dead enemy — dimmed, not targetable */\n.mini-boss-enemy--dead {\n  opacity: 0.4;\n  filter: grayscale(0.6);\n  cursor: default;\n}\n\n/* Invulnerable enemy (simultaneous boss while lieutenants stand) — purple */\n.mini-boss-enemy--invuln {\n  opacity: 0.9;\n  border-left-color: rgba(139, 92, 246, 0.6);\n  background: rgba(139, 92, 246, 0.06);\n}\n.mini-boss-enemy--invuln .mini-boss-enemy-node {\n  color: #c4b5fd;\n}\n.mini-boss-enemy--invuln .mini-boss-enemy-fill {\n  background: linear-gradient(90deg, #8b5cf6, #a78bfa);\n}\n\n/* Spawned mid-fight mini (simultaneous spawn pools) — dashed amber edge + a\n * one-shot entry flash (the element mounts fresh, keyed by identity). */\n.mini-boss-enemy--spawned {\n  border-left-style: dashed;\n  border-left-color: rgba(245, 158, 11, 0.7);\n  animation: miniBossEnemySpawn 700ms ease-out;\n}\n.mini-boss-enemy--spawned .mini-boss-enemy-node {\n  color: #fbbf24;\n}\n@keyframes miniBossEnemySpawn {\n  0% { transform: scale(0.9); opacity: 0; }\n  40% { transform: scale(1.04); opacity: 1; box-shadow: 0 0 18px rgba(245, 158, 11, 0.55); }\n  100% { transform: scale(1); box-shadow: none; }\n}\n\n/* Enemy currently performing its attack — red flash */\n.mini-boss-enemy--attacking {\n  border-color: #ef4444;\n  border-left-color: #ef4444;\n  background: rgba(239, 68, 68, 0.14);\n  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.5), 0 0 14px rgba(239, 68, 68, 0.35);\n  animation: miniBossEnemyAttack 0.5s ease;\n}\n@keyframes miniBossEnemyAttack {\n  0% { transform: scale(1); box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.2), 0 0 0 rgba(239, 68, 68, 0); }\n  35% { transform: scale(1.04); box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.75), 0 0 18px rgba(239, 68, 68, 0.5); }\n  100% { transform: scale(1); }\n}\n\n.mini-boss-enemy-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  min-width: 0;\n  margin-bottom: 5px;\n}\n\n.mini-boss-enemy-name,\n.mini-boss-enemy-node,\n.mini-boss-enemy-hp {\n  font-size: 9.5px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  font-variant-numeric: tabular-nums;\n}\n\n.mini-boss-enemy-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--bcb-text, #f5f5f5);\n}\n\n/* Inline clinical pathophys label after the gamified name (e.g. \"ANGIRA [RAAS]\").\n   Same FONT as the gamified name (weight + tracking match .mini-boss-enemy-name) so\n   it reads as one typeface; only the dim color and non-caps casing (preserves e.g.\n   \"Lp(a)\") set it apart. Extra left margin separates it from the name. Rides inside\n   the ellipsizing name span, so it truncates gracefully on a narrow rail. */\n.mini-boss-enemy-subconcept {\n  text-transform: none;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: var(--bcb-text-dim, rgba(255, 255, 255, 0.5));\n  margin-left: 0.3em;\n}\n\n.mini-boss-enemy-node,\n.mini-boss-enemy-hp {\n  color: var(--bcb-text-dim, rgba(255, 255, 255, 0.62));\n  white-space: nowrap;\n}\n\n.mini-boss-enemy-track {\n  height: 4px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.08);\n  /* relative so the diuresis reserve segment anchors to the track; overflow:hidden\n     already clips it to the pill. */\n  position: relative;\n}\n\n.mini-boss-enemy-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #ef4444, #f97316);\n  transition: width 180ms ease;\n}\n\n/* Diuresis \"reserve\" segment (Edward 2026-07-24): mirrors HPBar's .hp-pill-reserve-\n   fill for the roster-rail bar (which has its own markup). The HP the diuresis drain\n   will remove from this enemy next interaction (even-split share), overlaying the\n   right edge of the green fill — left/width set inline (left = pct - reservePct).\n   Diuresis cyan rgb(56,189,248). Only rendered when reservePct > 0, so non-HTN\n   rosters are untouched. */\n.mini-boss-enemy-reserve-fill {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  min-width: 2px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, rgba(56, 189, 248, 0.85) 0%, rgb(56, 189, 248) 100%);\n  box-shadow: inset 1px 0 0 rgba(56, 189, 248, 0.55);\n  transition: width 180ms ease, left 180ms ease;\n}\n\n.mini-boss-enemy-hp {\n  margin-top: 4px;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
